module.exports = __webpack_public_path__ + "static/media/Gambar banner-03.8937cc26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/survey-img/Gambar banner-03.png
// module id = 581
// module chunks = 0